import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { settingsTheme as t } from '../../../theme';

interface FormFieldProps {
  label: string;
  children: ReactNode;
  /** Mensaje de error de validación; se pinta en rojo bajo el control. */
  error?: string;
}

const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 7,
});

const Label = styled.label({
  fontFamily: t.font,
  fontSize: 12.5,
  fontWeight: 600,
  color: '#6b7178',
});

const ErrorText = styled.span({
  fontFamily: t.font,
  fontSize: 12,
  color: t.color.danger,
});

/**
 * Primitivo de formulario: etiqueta encima de su control y, opcionalmente, el
 * mensaje de error debajo. No sabe qué control envuelve, así que sirve para
 * inputs, segmentos o selectores de chips.
 */
const FormField = ({ label, children, error }: FormFieldProps) => (
  <Wrapper>
    <Label>{label}</Label>
    {children}
    {error ? <ErrorText>{error}</ErrorText> : null}
  </Wrapper>
);

export default FormField;
